import React from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";
import { ClockBadgeIcon, CrossBadgeIcon, ReviewDocIcon } from "./gateIcons";

export type ReviewCardVariant = "pending" | "rejected";

interface Props {
  variant: ReviewCardVariant;
  title: string;
  /** Body copy. Pass a node when the design needs a line break inside the paragraph. */
  description: React.ReactNode;
  descriptionClassName?: string;
  /** Footnote row (pending) or call-to-action (rejected), rendered under the body copy. */
  children?: React.ReactNode;
}

/**
 * The review-status card shared by the pending and rejected gate screens: a large document
 * glyph with a status badge, a headline, body copy, and a variant-specific footer.
 */
const OrganizationReviewCard: React.FC<Props> = ({
  variant,
  title,
  description,
  descriptionClassName,
  children,
}) => {
  const isRejected = variant === "rejected";

  return (
    <div className={styles.reviewCard}>
      <span
        className={classNames(styles.reviewIcon, {
          [styles.rejected]: isRejected,
        })}>
        <ReviewDocIcon className={styles.riDoc} />
        <span
          className={classNames(styles.reviewBadge, {
            [styles.rejected]: isRejected,
          })}>
          {isRejected ? <CrossBadgeIcon /> : <ClockBadgeIcon />}
        </span>
      </span>
      <h3>{title}</h3>
      <p className={descriptionClassName}>{description}</p>
      {children}
    </div>
  );
};

export default OrganizationReviewCard;
